import React from "react";
import { Link } from "react-router-dom";
import { FIRM, PRACTICE_AREAS } from "../lib/practiceAreas";
import { Logo } from "./Logo";
import { scrollToId } from "../hooks/useLenis";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#070709] border-t border-white/5 pt-20 pb-10 overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-60"
        style={{
          background:
            "radial-gradient(ellipse 60% 40% at 0% 100%, rgba(233,199,106,0.08), transparent 60%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo size={52} />
            <p className="mt-6 text-white/55 text-sm font-light leading-relaxed max-w-md">
              A niche London law firm offering partner-led legal services across
              immigration, family, property, crime and litigation.
            </p>
            <div className="mt-8">
              <div className="overline mb-3">Regulated by</div>
              <div className="text-white/75 text-sm">
                Solicitors Regulation Authority &middot; No. {FIRM.sra}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">Practice Areas</div>
            <ul className="space-y-3">
              {PRACTICE_AREAS.map((a) => (
                <li key={a.id}>
                  <button
                    data-testid={`footer-area-${a.id}`}
                    onClick={() => scrollToId("services")}
                    className="text-sm text-white/65 hover:text-[#E9C76A] transition-colors text-left"
                  >
                    {a.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="overline mb-5">Visit & Contact</div>
            <address className="not-italic text-sm text-white/70 font-light leading-relaxed space-y-3">
              <div>{FIRM.address}</div>
              <div>
                <a href={`tel:${FIRM.phone.replace(/\s/g, "")}`} className="hover:text-[#E9C76A] transition-colors">
                  T &nbsp; {FIRM.phone}
                </a>
              </div>
              <div>
                <a href={`mailto:${FIRM.email}`} className="hover:text-[#E9C76A] transition-colors">
                  E &nbsp; {FIRM.email}
                </a>
              </div>
              <div className="pt-2">
                <div className="overline mb-2">Free walk-in</div>
                {FIRM.walkInHours}
              </div>
            </address>
            <div className="mt-8 flex items-center gap-4">
              <img
                src={FIRM.cyberBadge}
                alt="Cyber Essentials Plus Certified"
                className="h-16 w-auto"
                data-testid="footer-cyber-badge"
              />
              <div className="text-[11px] text-white/40 leading-snug max-w-[180px]">
                Cyber Essentials Plus Certified — client data protected to UK government standard.
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="text-xs text-white/40 font-light">
            © {new Date().getFullYear()} Lawfields Solicitors. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-5 text-xs text-white/45 font-light tracking-wide">
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#E9C76A] transition-colors">Privacy Policy</Link>
            <span className="text-white/15">·</span>
            <Link to="/complaints" data-testid="footer-link-complaints" className="hover:text-[#E9C76A] transition-colors">Complaints</Link>
            <span className="text-white/15">·</span>
            <Link to="/terms" data-testid="footer-link-terms" className="hover:text-[#E9C76A] transition-colors">Terms of Use</Link>
            <span className="text-white/15">·</span>
            <Link to="/accessibility" data-testid="footer-link-accessibility" className="hover:text-[#E9C76A] transition-colors">Accessibility</Link>
            <span className="text-white/15 hidden sm:inline">·</span>
            <span className="text-white/35">SRA Regulated · ICO Registered</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
